import { useState } from 'react';
import './App.css';

const VR = () => {
  const [showPopup, setShowPopup] = useState(false);

  const links = [
    {
      url: "https://drive.google.com/drive/folders/1Wbam8b1itI7F1O74cqlOIKYG3bjwLMNp?usp=sharing",
      imgSrc: "car.jpeg",
      text: "Car Game",
    },
  ];

  const handleLinkClick = () => {
    setShowPopup(true);
  };

  const handleOkay = () => {
    window.open(links[0].url, "_blank");
    setShowPopup(false); 
  };

  return (
    <>
      <div id="dynamicLinks">
      <p style={{margin: "0px", marginBottom: "10px", fontWeight: "500", fontFamily: "cursive"}}>Virtual Reality - VR Projects</p>
        {links.map((link, index) => (
          <div key={index} onClick={handleLinkClick}>
            <div className="main-child">
              <div className="img-view">
                <img src={link.imgSrc} alt={link.text} />
              </div>
              <div className="text">
                <p>{link.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {showPopup && <div className="overlay"></div>}
      {showPopup && (
        <div className="popup">
          <div className="popup-content">
            <p style={{width: "300px"}}>This project demonstrates on Open World, Car Game.</p>
            <button onClick={handleOkay}>Okay</button>
          </div>
        </div>
      )}
    </>
  );
};

export default VR;
